<div
  class="tw-relative tw-hidden lg:tw-flex tw-flex-col archived-items-desktop"
  [style.--archived-table-viewport-height.px]="viewportHeightPx()"
>
  <app-generic-table
    class="archived-items-table tw-w-full tw-min-w-0 tw-h-auto"
    [items]="items()"
    [trackBy]="trackBy()"
    [rowKey]="rowKey()"
    [selectable]="true"
    [selectedKeys]="selectedKeys()"
    [selectAllScope]="'allLoaded'"
    [pageSize]="perPage()"
    [sort]="sort()"
    [hasMore]="hasMore()"
    [isLoadingMore]="isLoadingMore()"
    [rowHeightPx]="tableRowHeightPx"
    [autoFillViewport]="true"
    [virtualScrollMinBufferPx]="virtualScrollMinBufferPx()"
    [virtualScrollMaxBufferPx]="virtualScrollMaxBufferPx()"
    (selectionChange)="selectionChange.emit($event)"
    (sortChange)="sortChange.emit($event)"
    (loadMore)="loadMore.emit()"
  >
    <ng-container appGenericTableColumn field="name" header="Item Name" [sortable]="true" width="261px" widthXl="325px">
      <ng-template appGenericTableCellDef let-item>
        <app-truncation-tooltip
          [text]="item.name"
          [hostNgClass]="'tw-font-inter tw-font-semibold tw-text-sm tw-text-gray-900'"
        ></app-truncation-tooltip>
      </ng-template>
    </ng-container>

    <ng-container appGenericTableColumn field="type" header="Type" width="193px" widthXl="257px">
      <ng-template appGenericTableCellDef let-item>
        <app-truncation-tooltip
          [text]="item.type.toString().toLowerCase()"
          [hostNgClass]="{
            'tw-capitalize tw-w-fit tw-rounded-md tw-text-xs tw-font-inter tw-font-medium tw-px-2.5 tw-py-0.5': true,
            'tw-bg-blue-100 tw-text-blue-800': item.type === archivedItemType.PERSONA,
            'tw-bg-gray-100 tw-text-gray-900': item.type === archivedItemType.SESSION
          }"
        ></app-truncation-tooltip>
      </ng-template>
    </ng-container>

    <ng-container appGenericTableColumn field="archived_at" header="Archived On" [sortable]="true" width="193px" widthXl="257px">
      <ng-template appGenericTableCellDef let-item>
        @let archivedDate = item.archived_at | date: 'MMM d, yyyy';
        <app-truncation-tooltip
          [text]="archivedDate"
          [hostNgClass]="'tw-font-inter tw-font-normal tw-text-sm tw-text-gray-700'"
        ></app-truncation-tooltip>
      </ng-template>
    </ng-container>

    <ng-container appGenericTableColumn field="archived_by" header="Archived By" [sortable]="true" width="193px" widthXl="257px">
      <ng-template appGenericTableCellDef let-item>
        <app-truncation-tooltip
          [text]="item.archived_by"
          [hostNgClass]="'tw-font-inter tw-font-normal tw-text-sm tw-text-gray-700'"
        ></app-truncation-tooltip>
      </ng-template>
    </ng-container>

    <ng-container appGenericTableColumn field="actions" header="Actions" width="88px" widthXl="152px">
      <ng-template appGenericTableCellDef let-item>
        <app-dropdown
          [dropdownOptions]="menuOptions()"
          [widthInPX]="'190'"
          [heightInPX]="97"
          (optionClicked)="onMenuOptionClick(item, $event)"
        >
          <button
            type="button"
            class="tw-ml-4 tw-border tw-border-gray-200 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-w-5 tw-h-5 tw-p-1 tw-cursor-pointer focus:tw-bg-gray-100 dropdownButton"
          >
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path
                d="M12.6 8.39961C13.3732 8.39961 14 7.77281 14 6.99961C14 6.22641 13.3732 5.59961 12.6 5.59961C11.8268 5.59961 11.2 6.22641 11.2 6.99961C11.2 7.77281 11.8268 8.39961 12.6 8.39961Z"
                fill="currentColor"
              />
              <path
                d="M7 8.39961C7.7732 8.39961 8.4 7.77281 8.4 6.99961C8.4 6.22641 7.7732 5.59961 7 5.59961C6.2268 5.59961 5.6 6.22641 5.6 6.99961C5.6 7.77281 6.2268 8.39961 7 8.39961Z"
                fill="currentColor"
              />
              <path
                d="M1.4 8.39961C2.1732 8.39961 2.8 7.77281 2.8 6.99961C2.8 6.22641 2.1732 5.59961 1.4 5.59961C0.626801 5.59961 0 6.22641 0 6.99961C0 7.77281 0.626801 8.39961 1.4 8.39961Z"
                fill="currentColor"
              />
            </svg>
          </button>
        </app-dropdown>
      </ng-template>
    </ng-container>
  </app-generic-table>
</div>
